import './src/main.css'
import Decoration11 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration11.name, Decoration11)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration11/index.js